import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ExitSlipStudentFinishedState {
  value: boolean;
}

const initialState: ExitSlipStudentFinishedState = { value: false };

export const exitSlipStudentFinishedSlice = createSlice({
  name: 'exitSlipStudentFinished',
  initialState,
  reducers: {
    setExitSlipStudentFinished: (state: ExitSlipStudentFinishedState, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const selectedExitSlipStudentFinished = (state: RootState) => state.exitSlipFinished.value;

export const { setExitSlipStudentFinished } = exitSlipStudentFinishedSlice.actions;

export default exitSlipStudentFinishedSlice.reducer;
